var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"value":_vm.value,"label":_vm.label},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }